export interface IDevice {
  deviceId: string;
  uidUser: string;
  platform: string;
  logged: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export class DeviceModel {
  deviceId: string;
  uidUser: string;
  platform: string;
  logged: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IDevice) {
    this.deviceId = data.deviceId;
    this.uidUser = data.uidUser;
    this.platform = data.platform;
    this.logged = data.logged;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
